import React, { memo } from 'react';
import FeedIngressStream from './feed-ingress-stream';

interface Props {
	feedPosition: number;
	mediaId: string | number;
}

function FeedIngressStreamSpotlight({ feedPosition, mediaId }: Props) {
	return (
		<FeedIngressStream
			feedPosition={feedPosition}
			ingressStreamId={String(mediaId)}
			dropCallback={() => { }}
			isSpotlightFeed={true}
		/>
	);
}

export default memo(FeedIngressStreamSpotlight);